import React from "react";
import ReactPlayer from 'react-player/youtube'
const Card = ({ item }) => {
  return (
    <>
      <div className="video-area">
        <ul>
          {item.map((Val) => {
            return (
              <li key={Val.id}>
                <div className="card-body">
                <ReactPlayer 
                  url={Val.video} 
                  width="100%"
                  height="40vh"
                  controls={false}
                />
                  <div className="card-title">
                    <strong>{Val.title}</strong>
                  </div>
                  <div className="card-text">{Val.desc}</div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Card;
